import { Component, OnInit, Input, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-docs-modal',
  templateUrl: './view-docs-modal.component.html',
  styleUrls: ['./view-docs-modal.component.scss'],
  providers: [NgbCarouselConfig]
})

export class ViewDocsModalComponent implements OnInit {

  @Input() docsToView = [];

  constructor(
    public activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer,
    config: NgbCarouselConfig
  ) {
    // customize default values of carousels used by this component tree
    config.interval = 0;
    config.wrap = false;
    config.keyboard = true;
    config.showNavigationIndicators = false;
    config.showNavigationArrows = false;
  }

  // ngOnInit() {
  //   this.docsToView.forEach((doc: any) => {
  //     doc.id = doc.title.toLowerCase().split(' ').join('-');
  //     doc.sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, doc.document_url);
  //   });
  // }
  ngOnInit() {
    this.docsToView.forEach((doc: any) => {
      doc.id = doc.title.toLowerCase().split(' ').join('-');
      doc.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.sanitizer.sanitize(SecurityContext.URL ,doc.document_url));
    });
  }

  closeModal() {
    this.activeModal.close(true);
  }
}
